import * as RadixContextMenu from '@radix-ui/react-context-menu';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ContextMenuSeparatorProps = RadixContextMenu.ContextMenuSeparatorProps;

export const ContextMenuSeparator = memo(({ className, ...restOfProps }: ContextMenuSeparatorProps) => {
  return (
    <RadixContextMenu.Separator
      className={cn('-mx-2 h-px shrink-0 ads:bg-ads-gray-4 bg-gray-4', className)}
      data-testid="CONTEXT_MENU_SEPARATOR"
      {...restOfProps}
    />
  );
});

ContextMenuSeparator.displayName = 'ContextMenuSeparator';
